export const BLANK_LABEL = '(blank)';
export const ASC_VALUE = 'asc';
export const DSC_VALUE = 'dsc';

export default {
  BLANK_LABEL,
  ASC_VALUE,
  DSC_VALUE,
};
